export const brazilianStates = [
  { state: 'AC', stateName: 'Acre' },
  { state: 'AL', stateName: 'Alagoas' },
  { state: 'AP', stateName: 'Amapá' },
  { state: 'AM', stateName: 'Amazonas' },
  { state: 'BA', stateName: 'Bahia' },
  { state: 'CE', stateName: 'Ceará' },
  { state: 'DF', stateName: 'Distrito Federal' },
  { state: 'ES', stateName: 'Espírito Santo' },
  { state: 'GO', stateName: 'Goiás' },
  { state: 'MA', stateName: 'Maranhão' },
  { state: 'MT', stateName: 'Mato Grosso' },
  { state: 'MS', stateName: 'Mato Grosso do Sul' },
  { state: 'MG', stateName: 'Minas Gerais' },
  { state: 'PA', stateName: 'Pará' },
  { state: 'PB', stateName: 'Paraíba' },
  { state: 'PR', stateName: 'Paraná' },
  { state: 'PE', stateName: 'Pernambuco' },
  { state: 'PI', stateName: 'Piauí' },
  { state: 'RJ', stateName: 'Rio de Janeiro' },
  { state: 'RN', stateName: 'Rio Grande do Norte' },
  { state: 'RS', stateName: 'Rio Grande do Sul' },
  { state: 'RO', stateName: 'Rondônia' },
  { state: 'RR', stateName: 'Roraima' },
  { state: 'SC', stateName: 'Santa Catarina' },
  { state: 'SP', stateName: 'São Paulo' },
  { state: 'SE', stateName: 'Sergipe' },
  { state: 'TO', stateName: 'Tocantins' }
];
